import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const OrganizationSeries = lazy(() => import('./series-page'));

export const OrganizationSeriesRoute = () => {
  return (
    <LazyRoute>
      <OrganizationSeries />
    </LazyRoute>
  );
};
